export default function Footer() {

    return <footer>
        <div> Max Mustermann</div>
        <div> Tel: 0123 - 456789</div>
    </footer>
}
